import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import BaseTextButton from "../../../../components/BaseTextButton";
import "./style.scss";
export default function RemoveGame({ game, onClick }) {
  RemoveGame.propTypes = {
    onClick: PropTypes.func,
  };
  const { t } = useTranslation();
  return (
    <BaseTextButton
      iconStyle="icon-lines"
      className="remove-game-button"
      onClick={onClick}
      icon="trash"
    >
      {!game.answers.length ? t("personal_acc.remove_test") : t("personal_acc.remove_game")}
    </BaseTextButton>
  );
}
